import React from "react";

import { useTranslation } from "react-i18next";

import { Button } from "@/src/components/ui/button";

import type { JSX } from "react";

interface AppearanceHeaderProps {
  isDirty: boolean;
  isSaving: boolean;
  onCancel: () => void;
  onSave: () => void;
}

function AppearanceHeader({
  isDirty,
  isSaving,
  onCancel,
  onSave,
}: AppearanceHeaderProps): JSX.Element {
  const { t } = useTranslation("editor-appearance");

  return (
    <div className="bg-card flex h-14 shrink-0 items-center justify-between border-b px-4">
      <span className="text-foreground text-sm font-semibold">
        {t("title")}
      </span>
      <div className="flex items-center gap-2.5">
        {isDirty ? (
          <span className="text-status-warning flex items-center gap-1.5 text-xs">
            <span className="bg-status-warning size-1.5 rounded-full" />
            {t("unsavedChanges")}
          </span>
        ) : null}
        <Button onClick={onCancel} type="button" variant="outline">
          {t("cancel")}
        </Button>
        <Button disabled={!isDirty || isSaving} onClick={onSave} type="button">
          {t("save")}
        </Button>
      </div>
    </div>
  );
}

export default AppearanceHeader;
